module.exports = __webpack_public_path__ + "static/media/underline.8af97cd4.svg";